import { AccountActions, selectAccountData } from '@store/reducers/account'
import { useDispatch, useSelector } from 'react-redux'

import type { AccountFormHandler } from '../types'

export const useForm = () => {
  const dispatch = useDispatch()
  const state = useSelector(selectAccountData)

  const onChange: AccountFormHandler = (name) => (value) => {
    dispatch(
      AccountActions.update({
        [name]: value,
      })
    )
  }

  const onChangeEmail = (email: string) => {
    dispatch(AccountActions.changeEmail({ email }))
  }

  return {
    onChangeEmail,
    onChange,
    state,
  }
}
